<template>
  <div class="ml_platformsessionsrules">
    <div class="ml_platformsessionsrules_title">仲裁将根据以下规则进行判定：</div>
    <div class="rule-table">

      <!-- 仲裁项目表格 -->
      <div class="table" v-for="(item,index) in rules" :key="index">
        <div class="table-row" v-if="index==0">
          <div class="table-cell">评分分级</div>
        </div>
        <div class="table-row scoreLevel">
          <div class="table-cell">{{item.scoreLevel}}</div>
        </div>

        <!-- 表头 -->
        <div class="table-row header-row">
          <div class="table-cell">仲裁项目</div>
          <div class="table-cell">处理方案</div>
        </div>

        <!-- 数据行 -->
        <div class="table-row table-content" v-for="(items, indexs) in item.arbitrationList" :key="indexs">
          <div class="table-cell">{{ items.item }}</div>
          <div class="table-cell">{{ items.solution }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      rules:[
        {
          scoreLevel:'骨架B级以上且内饰40分以上',
          arbitrationList: [
            { item: "使用性质", solution: "赔付" },
            { item: "注册日期(年月)", solution: "赔付" },
            { item: "强制报废期限(年月)", solution: "赔付" },
            { item: "车辆登记证书上的变更记录", solution: "赔付" },
            { item: "水渍残留车辆", solution: "赔付" },
            { item: "火烧事故车辆", solution: "赔付" },
            { item: "碰撞事故车辆", solution: "赔付" },
            { item: "新能源车辆动力电池变形或鼓包", solution: "赔付" },
            { item: "表显里程(千公里级)", solution: "赔付" },
            { item: "车型名称", solution: "赔付" },
            { item: "车牌所属地", solution: "赔付" },
            { item: "出厂日期(年月)", solution: "赔付" },
            { item: "交强险有效期(年月)", solution: "退" },
            { item: "年检有效期(年月)", solution: "退" },
            { item: "购置税", solution: "退" },
            { item: "过户车辆需恢复原貌的改装", solution: "退" },
            { item: "外观覆盖件更换", solution: "退" },
            { item: "车辆码表改动", solution: "第三方数据最后记载历程大于表显里程5万公里，可退" },
            { item: "车辆是否曾为租赁户", solution: "退" },
            { item: "新能源车辅助动力电池拆卸", solution: "退" }
          ]
        },
        {
          scoreLevel: "骨架C级内饰40分以上",
          arbitrationList: [
            { item: "使用性质", solution: "赔付" },
            { item: "注册日期(年月)", solution: "赔付" },
            { item: "强制报废期限(年月)", solution: "赔付" },
            { item: "水渍残留车辆", solution: "赔付" },
            { item: "火烧事故车辆", solution: "赔付" },
            { item: "碰撞事故车辆", solution: "赔付" },
            { item: "车型名称", solution: "赔付" },
            { item: "车牌所属地", solution: "退" },
            { item: "表显里程(千公里级)", solution: "退" },
            { item: "交强险有效期(年月)", solution: "退" },
            { item: "年检有效期(年月)", solution: "退" },
            { item: "购置税", solution: "退" },
            { item: "车辆登记证书上的变更记录", solution: "退" },
            { item: "过户验车需恢复原貌的改装", solution: "退" }
          ]
        },
        {
          scoreLevel: "骨架D级",
          arbitrationList: [
            { item: "使用性质", solution: "赔付" },
            { item: "注册日期(年月)", solution: "赔付" },
            { item: "强制报废期限(年月)", solution: "赔付" },
            { item: "交强险有效期(年月)", solution: "退" },
            { item: "年检有效(年月)", solution: "退" },
            { item: "购置税", solution: "退" },
            { item: "水渍残留车辆", solution: "退" },
            { item: "火烧事故车辆", solution: "退" },
            { item: "碰撞事故车辆", solution: "退" }
          ]
        }
      ]
    };
  },
  computed: {},
  mounted() { },
  methods: {}
}

</script>
<style lang='scss'>
.ml_platformsessionsrules {
  background: #FFFFFF;
  padding: 0 15px;

  .ml_platformsessionsrules_title {
    font-size: 14px;
    color: #292D33;
    font-weight: 500;
    line-height: 20px;
    padding: 12px 0;
  }

  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .section {
    margin-bottom: 15px;
  }

  .section-title {
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 5px;
  }

  .section-content {
    font-size: 14px;
    color: #333;
  }

  .table {
    border: 1px solid #E9E9E9;;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 15px;
  }

  .scoreLevel{
    background: #F7F7F7;
    color: #292D33;
    font-weight: 600;
  }

  .table-row {
    display: flex;
    border-bottom: 1px solid #E9E9E9;;
  }

  .table-row:last-child {
    border-bottom: none;
  }
  .table-cell {
    flex: 1;
    padding: 10px;
    font-size: 14px;
    line-height: 20px;
    color: #292D33;
    word-wrap: break-word;
    word-break: break-all;
  }
  .header-row {
    .table-cell{
      color: #979797;
    }
  }

  .table-content{
    &:nth-child(2n){
      background: #F7F7F7;
    }
    .table-cell:first-child{
      border-right: 1px solid #E9E9E9;;
    }
  }
}
</style>